import { Filter } from './Filter'
import { WizardStep } from 'app-view/components/Wizard'

export const OPEN_OFFER_FILTER_STEPS: WizardStep[] = [
  {
    name: 'filter',
    component: Filter,
  },
]
